import React from 'react';
import { Minimize2 } from 'styled-icons/feather/Minimize2';

function RetractIcon(props) {
  return (
    <Minimize2 {...props} className={'icon'} />
  );
}

export default RetractIcon;
